import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button
} from '@mui/material';
import { useGlobal } from '../contexts/GlobalContext';

const BlacklistSection = ({ onUpdate }) => {
  const { accountId: defaultAccountId } = useGlobal();
  const [consoleAccountId, setConsoleAccountId] = useState(defaultAccountId || '');

  const handleExcludeBlacklistedUsers = () => {
    const updateData = {
      action: 'exclude',
      filter: 'console_account',
      field: 'user_id',
      path: 'exclude_user_ids',
      value: consoleAccountId.trim()
    };
    
    onUpdate(updateData);
  };

  const handleExcludeBlacklistedItems = () => {
    const updateData = {
      action: 'exclude',
      filter: 'console_account',
      field: 'item_id',
      path: 'exclude_item_ids',
      value: consoleAccountId.trim()
    };
    
    onUpdate(updateData);
  };

  return (
    <Box>
      <TextField
        fullWidth
        sx={{ mb: 2 }}
        label="Console Account ID"
        value={consoleAccountId}
        onChange={(e) => setConsoleAccountId(e.target.value)}
        placeholder="Enter console account ID"
      />
      
      <Box sx={{ display: 'flex', gap: 2, flexDirection: 'column' }}>
        <Button
          variant="contained"
          color="error"
          onClick={handleExcludeBlacklistedUsers}
          disabled={!consoleAccountId.trim()}
          fullWidth
        >
          Exclude Blacklisted Users
        </Button>
        
        <Button
          variant="contained"
          color="error"
          onClick={handleExcludeBlacklistedItems}
          disabled={!consoleAccountId.trim()}
          fullWidth
        >
          Exclude Blacklisted Items
        </Button>
      </Box>
    </Box>
  );
};

export default BlacklistSection;

